import { render, staticRenderFns } from "./EmmitedNotificationDetail.vue?vue&type=template&id=817894fa&"
import script from "./EmmitedNotificationDetail.vue?vue&type=script&lang=js&"
export * from "./EmmitedNotificationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports